import * as S from "../../Style/Page/Fork.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleFork.js";
import HatPageTopLine from "../../Component/ForkPageTopLine.js";
// const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/42. 중국법인.576b78ed33d47ae2f6ba.jpg`;
import Factory1 from "../../assets/ForkLiftBusiness/중국법인.png";
const Item1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/중국.02fdf3ba3de530d929a0.png`;
const Item2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 09.1023c089a1994a6196ab.jpg`;
const ForkHeadOffice11 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"지게차사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/Introduce">
                <div className="kor">지게차사업</div>
                <div className="eng">Fork Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                <div className="kor">지역별법인</div>
                <div className="eng">Corporation by region</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">클라크</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">지역별법인</div>
                  <div className="eng">Corporation by region</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"830px"}>
            <S.NavItem>
              <Link to="/ForkLiftBusiness/HeadOffice11">
                <div className="kor">중국법인</div>
                <div className="eng">China Company</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeUsa">
                  <div className="kor">클라크 미국본사</div>
                  <div className="eng">USA HQ</div>
                </Link>
              </S.NavItem>
<S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOfficeMexico">
                  <div className="kor">멕시코 법인</div>
                  <div className="eng">Mexico Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice2">
                  <div className="kor">브라질 법인</div>
                  <div className="eng">Brasil Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice3">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa-Rica Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice4">
                  <div className="kor">독일 법인</div>
                  <div className="eng">Germany Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice5">
                  <div className="kor">프랑스 법인</div>
                  <div className="eng">France Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice6">
                  <div className="kor">호주 법인</div>
                  <div className="eng">Australia Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice7">
                  <div className="kor">싱가폴 법인</div>
                  <div className="eng">Singapore Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                            <Link to="/ForkLiftBusiness/HeadOfficeVnHq">
                                              <div className="kor">베트남 판매법인</div>
                                              <div className="eng">Vietnam Sales Company</div>
                                            </Link>
                                          </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice8">
                  <div className="kor">한국 법인 (부천)</div>
                  <div className="eng">Korea HQ (Bucheon)</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice9">
                  <div className="kor">베트남 1공장</div>
                  <div className="eng">Vietnam Company1</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice10">
                  <div className="kor">베트남 2공장</div>
                  <div className="eng">Vietnam Company2</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice11">
                  <div className="kor">중국법인</div>
                  <div className="eng">China Company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                                                                      <Link to="/ForkLiftBusiness/HeadOfficeIdnesia">
                                                                                        <div className="kor">인도네시아 법인</div>
                                                                                        <div className="eng">Indonesia Company</div>
                                                                                      </Link>
                                                                                    </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/HeadOffice12">
                  <div className="kor">한국 법인 (창원)</div>
                  <div className="eng">Korea Company (Changwon) </div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                                                                        <Link to="/ForkLiftBusiness/HeadOfficeRnd">
                                                                          <div className="kor">글로벌 연구소</div>
                                                                          <div className="eng">Global R&D Center</div>
                                                                        </Link>
                                                                      </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"중국 법인"} titleeng={"Factory Interior / Major Production Products"} website={"http://www.clarkmhc.cn/"} />
            <div className="page-text">
              <h2>Qingdao CLARK Material Handling / CMHCN</h2>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img plus" alt="" />
              <div className="holder-name">
                <div className="kor">중국 법인</div>
                <div className="eng">Qingdao CLARK Material Handling / CMHCN</div>
              </div>
            </S.ImgHolderFullsize>

            <PageTitle titleko={"공장 내부 / 주요판매제품"} titleeng={"Factory Interior / Major Production Products"} />
            <S.ImgHolderFlex className="start">
              <S.ImgHolderHarf>
                <img src={Item2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">공장 내부</div>
                  <div className="eng">Factory Interior</div>
                </div>
              </S.ImgHolderHarf>
              <img src={Item1} className="img-item-plus" alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요 이력"} titleeng={"Major History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">Qingdao CLARK Material Handling 법인개요</div>
                    <div className="eng">Company Profile of Qingdao CLARK Material Handling</div>
                  </div>
                  <div className="kor">법인 설립: 2005년</div>
                  <div className="eng">Establishment : 2005</div>
                </div>
              </div>
              <div className="kor">
                ※ 클라크 글로벌 종합 생산 공장 (완성차)
                <br />
                ※ 클라크 지역 연구소 역할 수행
                <br />※ 클라크 글로벌 부품소싱 역할 수행
              </div>
              <div className="eng">
                ※ CLARK Global production factory (finished truck) <br />
                ※ CLARK local R&D center role <br />
                ※ CLARK Global Parts sourcing role <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ForkHeadOffice11;
